import { cn } from "@src/lib/utils/cn";
import React, { ComponentProps, CSSProperties, forwardRef } from "react";

type Props = ComponentProps<"div"> & {
  overflow?: CSSProperties["overflow"];
  flex?: CSSProperties["flex"];
  alignSelf?: CSSProperties["alignSelf"];
  innerStyle?: CSSProperties;
  className?: string;
  innerClassName?: string;
  onScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  hideScrollbar?: boolean;
  innerRef?: React.RefObject<HTMLDivElement | null>;
};

const ScrollableFlexGrow = forwardRef<HTMLDivElement, Props>(
  (
    {
      innerStyle,
      style,
      overflow = "auto",
      flex = 1,
      alignSelf,
      children,
      onScroll,
      hideScrollbar,
      className,
      innerClassName,
      innerRef,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        id={"sfg-outer"}
        ref={ref}
        style={{
          position: "relative",
          flex: flex,
          alignSelf: alignSelf,
          ...style,
        }}
        className={cn(className)}
        {...props}
      >
        <div
          id={"sfg-inner"}
          ref={innerRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: overflow,
            display: "flex",
            flexDirection: "column",
            ...innerStyle,
          }}
          className={cn(
            hideScrollbar &&
              "[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:h-0",
            innerClassName,
          )}
          onScroll={onScroll}
        >
          {children}
        </div>
      </div>
    );
  },
);

ScrollableFlexGrow.displayName = "ScrollableFlexGrow";

export default ScrollableFlexGrow;
